module.exports = __webpack_public_path__ + "static/media/DSC_0283.404e8bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0283.jpg
// module id = 661
// module chunks = 0